import {
  Paper,
  Typography,
  Divider,
  Box,
  CircularProgress,
  Alert,
} from "@mui/material";
import { ReactNode } from "react";
import { useAppTranslation } from "../../hooks/useAppTranslation";

type Props = {
  title: string;
  actions?: ReactNode;
  loading?: boolean;
  error?: string | null;
  empty?: boolean;
  emptyText?: string;
  children?: ReactNode;
};

export default function ReadonlyTableSection({
  title,
  actions,
  loading = false,
  error = null,
  empty = false,
  emptyText = "Brak danych",
  children,
}: Props) {
  const { t } = useAppTranslation("common");

  return (
    <Paper sx={{ p: 2, mt: 2 }}>
      {/* HEADER */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="subtitle1">
          {t(title)}
        </Typography>

        {actions}
      </Box>

      <Divider sx={{ my: 2 }} />

      {loading && (
        <Box>
          {t("Pobieranie...")} <CircularProgress size={20} />
        </Box>
      )}

      {!loading && error && <Alert severity="error">{error}</Alert>}

      {!loading && !error && empty && (
        <Typography variant="body2" color="text.secondary">
          {t(emptyText)}
        </Typography>
      )}

      {!loading && !error && !empty && children}
    </Paper>
  );
}
